/**
 * 待办红点计数消费 hook（S2-2）
 *
 * 用法：
 *   const { count, refresh } = useTodoCount();
 *   - count：侧边栏「待办中心」徽标计数（无权限角色恒为 0）
 *   - refresh：手动刷新（进入待办中心 / 推进回退成功后调用）
 */

import { useContext } from 'react';
import { TodoCountContext, type TodoCountContextValue } from '@/components/common/TodoCountProvider';
export function useTodoCount(): TodoCountContextValue {
  return useContext(TodoCountContext);
}

export default useTodoCount;
